import type { ReactNode } from 'react';
import { useDocumentTitle } from '../../lib/title.ts';
import './Auth.css';

/**
 * Frame of the screens before the app shell (design/reference/Login.dc.html): reading content at
 * the top, actions pinned to the bottom within thumb reach.
 */
export function AuthScreen({
  title,
  busy = false,
  children,
  footer,
}: {
  /** Browser tab title. */
  title?: string;
  busy?: boolean;
  children?: ReactNode;
  /** Actions at the bottom (primary Button first). */
  footer?: ReactNode;
}) {
  useDocumentTitle(title);
  return (
    <main className="auth" aria-busy={busy || undefined}>
      <div className="auth__body">{children}</div>
      {footer && <div className="auth__footer">{footer}</div>}
    </main>
  );
}

/**
 * The place-setting mark from design/brand/logo/dishly-mark.svg: ink plate, terracotta knife. Inline
 * so the colours follow the theme tokens. Decorative: the page heading names Dishly.
 */
export function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 96 96" aria-hidden="true" focusable="false">
      <path
        className="brand-mark__plate"
        fillRule="evenodd"
        d="M40 16a38 38 0 1 1 0 76a38 38 0 1 1 0-76zm0 10a28 28 0 1 0 0 56a28 28 0 1 0 0-56z"
      />
      <circle className="brand-mark__well" cx="40" cy="54" r="16" />
      <path className="brand-mark__knife" d="M93 87V4C85.5 7 82 18 82 32v55a5.5 5.5 0 0 0 11 0z" />
    </svg>
  );
}

/** Serif wordmark, "ly" in terracotta. */
export function Wordmark() {
  return (
    <span className="wordmark" aria-hidden="true">
      Dish<i>ly</i>
    </span>
  );
}
